import { RouteObject } from 'react-router-dom';
import { RouteMeta } from '@/pages/routes';
import { states } from '@/lib/storage.ts';

const route: RouteObject = {
	path: 'scraper',
	id: 'scraper',
	loader: () => ({
		meta: {
			title: 'Scraper',
			to: { id: 'scraperHome' },
			htmlTitlePattern: '#title :: Scraper ',
		} as RouteMeta,
	}),
	lazy: async () => ({ Component: (await import('@/modules/scraper/Layout')).default }),
	children: [
		{
			id: 'scraperHome',
			index: true,
			path: '',
			lazy: async () => ({ Component: (await import('@/modules/scraper/pages/Home')).default }),
			loader: () => ({
				meta: {
					title: 'Home',
					disabled: true,
				} as RouteMeta,
			}),
		},
		{
			id: 'scraperStateHome',
			index: true,
			path: ':state',
			lazy: async () => ({ Component: (await import('@/modules/scraper/pages/StateHome.tsx')).default }),
			loader: ({ params }) => ({
				meta: {
					title: `${states.find((s) => s.abbreviation === params?.state)?.name || ''}`,
					disabled: true,
				} as RouteMeta,
			}),
		},
		{
			id: 'scraperStateDB',
			index: true,
			path: ':state/db',
			lazy: async () => ({ Component: (await import('@/modules/scraper/pages/ScraperDB.tsx')).default }),
			loader: ({ params }) => ({
				meta: {
					title: `${states.find((s) => s.abbreviation === params?.state)?.name || ''} Database`,
					disabled: true,
				} as RouteMeta,
			}),
		},
		{
			id: 'scraperParserProdocCa',
			index: true,
			path: 'parser/prodoc-ca',
			lazy: async () => ({ Component: (await import('@/modules/scraper/pages/ParserProDocCa.tsx')).default }),
			loader: ({}) => ({
				meta: {
					title: `Parser Property Document CA`,
					disabled: true,
				} as RouteMeta,
			}),
		},
		{
			id: 'scraperParserProdocCo',
			index: true,
			path: 'parser/prodoc-co',
			lazy: async () => ({ Component: (await import('@/modules/scraper/pages/ParserProDocCo.tsx')).default }),
			loader: ({}) => ({
				meta: {
					title: `Parser Property Document CO`,
					disabled: true,
				} as RouteMeta,
			}),
		},
		{
			id: 'scraperParserProdocNy',
			index: true,
			path: 'parser/prodoc-ny',
			lazy: async () => ({ Component: (await import('@/modules/scraper/pages/ParserProDocNy.tsx')).default }),
			loader: ({}) => ({
				meta: {
					title: `Parser Property Document NY`,
					disabled: true,
				} as RouteMeta,
			}),
		},
		{
			id: 'scraperParserAz',
			index: true,
			path: 'parser/az',
			lazy: async () => ({ Component: (await import('@/modules/scraper/pages/ParserAz.tsx')).default }),
			loader: ({}) => ({
				meta: {
					title: `Parser AZ`,
					disabled: true,
				} as RouteMeta,
			}),
		},
		{
			id: 'scraperParserProdocFl',
			index: true,
			path: 'parser/prodoc-fl',
			lazy: async () => ({ Component: (await import('@/modules/scraper/pages/ParserProDocFl.tsx')).default }),
			loader: ({}) => ({
				meta: {
					title: `Parser Property Document FL`,
					disabled: true,
				} as RouteMeta,
			}),
		},
		{
			id: 'scraperParserProdocTx',
			index: true,
			path: 'parser/prodoc-tx',
			lazy: async () => ({ Component: (await import('@/modules/scraper/pages/ParserProDocTx.tsx')).default }),
			loader: ({}) => ({
				meta: {
					title: `Parser Property Document TX`,
					disabled: true,
				} as RouteMeta,
			}),
		},
	],
};

export default route;
